
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgCeoNew from '@/modules/admin/ceos/_components/DlgCeoNew.vue';
  import DlgCeoDelete from '@/modules/admin/ceos/_components/DlgCeoDelete.vue';
  import DlgCeoUpdate from '@/modules/admin/ceos/_components/DlgCeoUpdate.vue';

  @Component({
    components: {DlgCeoUpdate, DlgCeoDelete, DlgCeoNew, Card},
  })
  export default class VCeos extends Vue {
    @Action('admin/ceos/read') private read!: () => Promise<void>;
    @Getter('admin/ceos/all') private ceos!: any;

    private headers: any = [
      {
        text: 'Unternehmen',
        align: 'left',
        value: 'company',
      },
      {
        text: 'Vorname',
        align: 'left',
        value: 'title',
      },
      {
        text: 'Nachname',
        align: 'left',
        value: 'title',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'title',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.read();
      this.loading = false;
    }
  }
